import React, { useEffect, useState } from 'react';
import { Container, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DisplayDayAndFullDate } from '../../../utils/formats';
import VorDerForderung from './structure/VorDerForderung';
import BeendeteForderung from './structure/BeendeteForderung';
import AntraegeInForderung from './structure/AntraegeInForderung';
import EInstellung from './structure/EInstellung';
import Nachrichten from './structure/Nachrichten';
import GetRecord from '../../../lib/api/GetRecord';
import { APIS } from '../../../lib/constants/apis';
import { get } from 'lodash';
import { getLocalstorageToken } from '../../../context/AuthHelper';
import { removeDataKeys, removeNullDeep } from '../../../utils/helper';

import Schema from '../../../lib/paths/organisation_FULL_Paths.json';
const P = Schema.attributes;

function MeinBereich() {
	const [orgaData, setOrgaData] = useState({});

	useEffect(() => {
		const fetch = async () => {
			let fields = ['Geschaeftsbezogene_Daten_Name_Der_Organisation'];
			try {
				let res = await GetRecord(APIS.Organisation, get(getLocalstorageToken(), 'organisationId'), [], [], [], [], fields);
				if (res) {
					setOrgaData(removeNullDeep(removeDataKeys(get(res, 'data'))));
				}
			} catch (err: any) {
				console.error('ERROR: Fetching Organisation Daten ', err);
			}
		};
		fetch();
	}, []);

	return (
		<>
			<Container>
				<Stack direction={'row'} justifyContent={'space-between'}>
					<Typography variant="h3" component={'h1'}>
						{' '}
						Willkommen, {get(orgaData, P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path)}
					</Typography>
					<Typography variant="h3"> {DisplayDayAndFullDate(new Date().toISOString())}</Typography>
				</Stack>
				<Grid container columns={{ xs: 1, sm: 2, md: 3 }} spacing={4}>
					<Grid xs={3} sm={1} md={1}>
						<VorDerForderung />
						<BeendeteForderung />
					</Grid>
					<Grid xs={3} sm={1} md={1}>
						<AntraegeInForderung />
						<EInstellung />
					</Grid>
					<Grid xs={3} sm={2} md={1}>
						<Nachrichten />
					</Grid>
				</Grid>
			</Container>
		</>
	);
}

export default MeinBereich;
